import slug from 'slug';
export function handleSlugGenerator(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[slug-source]');
	} else {
		var $cont = $(selector + ' [slug-source]');
	}

	// pomoci extend nastavim pripadnou upravu mapy pro znaky
	slug.extend({'Ъ': 'u'});
	slug.extend({'ъ': 'u'});

	$cont.each(function (idx) {
		let $el = $(this);

		if (! $el.is('input')) {
			return;
		}

		let $form = $el.closest('form');
		let $slugUrl = $form.find('[slug-target]');
		let $shop = $form.find('select[name="shop"]');
		let shopUrl = $shop.find('option:selected').text();

		let slugOptions = {
			replacement: '-',
			lower: true,
		}

		$el.keyup(function() {
			clearTimeout(window.slugTimeout);
			window.slugTimeout = setTimeout(function () {
				$slugUrl.val('/' + slug($el.val(), slugOptions));
			}, 100);
		})
	});
}